import React from 'react';
import styles from '../TradeFlowTrackingTab.module.css';

interface DataSectionProps {
  title: string;
  tabNumber: number;
  description?: string;
  loading: boolean;
  isFetching?: boolean;
  error: string | null;
  emptyMessage?: string;
  dataCount: number;
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
  children: React.ReactNode;
}

const DataSection: React.FC<DataSectionProps> = ({
  title,
  tabNumber,
  description,
  loading,
  isFetching = false,
  error,
  emptyMessage = 'No data found for the selected filters.',
  dataCount,
  page,
  totalPages,
  total,
  onPageChange,
  children,
}) => {
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2>{title}</h2>
        <span className={styles.sectionBadge}>Tab {tabNumber}</span>
        {isFetching && !loading && (
          <span className={styles.autoRefreshBadge}>Refreshing...</span>
        )}
      </div>
      {description && <p className={styles.sectionDescription}>{description}</p>}

      {error && <div className={styles.errorBanner}>{error}</div>}

      {loading && dataCount === 0 ? (
        <div className={styles.loadingState}>Loading data...</div>
      ) : dataCount === 0 && !isFetching ? (
        <div className={styles.emptyState}>{emptyMessage}</div>
      ) : (
        <>
          {isFetching && !loading && (
            <div className={styles.refreshIndicator} />
          )}
          {children}
          <div className={styles.pagination}>
            <button
              disabled={page <= 1}
              onClick={() => onPageChange(Math.max(1, page - 1))}
              className={styles.paginationButton}
            >
              Previous
            </button>
            <span className={styles.paginationInfo}>
              Page {page} of {totalPages} ({total} total)
            </span>
            <button
              disabled={page >= totalPages}
              onClick={() => onPageChange(page + 1)}
              className={styles.paginationButton}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default DataSection;
